import script from "./redirect.vue?vue&type=script&lang=ts"
export * from "./redirect.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__